export default __webpack_public_path__ + "static/media/companies.3849d521.svg";